import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { submit } from 'redux-form';
import { createStructuredSelector } from 'reselect';

import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import asyncComponent from 'ggApp/shared/components/async';
import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import { SETTINGS_FORM_TYPE } from '../settingsForm';

// Async components
const CookiePolicyModal = asyncComponent(() => import('./modal'), {
    timeout: 0,
});

const enhance = compose(
    withDeviceInfo,
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
        }),
        (dispatch) => ({
            submitForm: bindActionCreators(() => submit(SETTINGS_FORM_TYPE), dispatch),
        }),
    ),
);

// Async export
export default enhance(CookiePolicyModal);
